import React from 'react';
import PropTypes from 'prop-types';
import { scrollToRegistration, scrollToSection } from '@/utils/scrollToSection';

const ProgramCta = ({ children, className = '', variant = 'primary', href, onClick }) => {
  const handleClick = () => {
    onClick?.();

    if (href?.startsWith('#')) {
      const sectionId = href.slice(1);
      if (sectionId) {
        scrollToSection(sectionId);
      }
      return;
    }

    if (href) {
      window.location.href = href;
      return;
    }

    scrollToRegistration();
  };

  return (
    <button
      type="button"
      className={`program-cta program-cta--${variant} ${className}`.trim()}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

ProgramCta.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'outline', 'light', 'accent']),
  href: PropTypes.string,
  onClick: PropTypes.func,
};

ProgramCta.defaultProps = {
  className: '',
  variant: 'primary',
  href: undefined,
  onClick: undefined,
};

export default ProgramCta;
